import { Icon } from '@/components'
import Spinner from '@/components/Spinner'
import { numberWithCommas } from '@/util/numberHelpers'
import { useArcade } from '@/features/arcade/provider'
import { useArcadeInventoryQuery } from '@/api/resources/arcade/inventory/get'
import { isNull } from '@/util/typeHelper'
import { RANK_ICONS } from '@/features/arcade/constants'
import { determineRank } from '@/features/arcade/utils'

const InventoryStat = ({ value }: { value?: number }) => {
  if (value === undefined)
    return (
      <div className="relative w-4">
        <Spinner />
      </div>
    )

  return numberWithCommas(value)
}

export const SeasonStats = () => {
  const { isArcadeLoaded, season, player } = useArcade()

  const { data: inventoryQueryData } = useArcadeInventoryQuery({
    account: player.account
  })

  const inventoryData = inventoryQueryData?.data

  if (!isArcadeLoaded) return null

  const { rank } = player

  const rankThreshold = season.rankThreshold
  const isEligible = !isNull(rank) && rank <= rankThreshold

  const rankGapSign = rank !== rankThreshold ? (isEligible ? '+' : '-') : ''

  const formattedRankGap = !isNull(rank)
    ? `${rankGapSign}${numberWithCommas(Math.abs(rankThreshold - rank))}`
    : ''

  const pointsNeeded = inventoryData?.points_to_threshold
  const availablePoints = inventoryData?.arcade_inventory_value.points_available

  return (
    <section className="border-y-1 border-solid border-gray-700 py-2 mx-1 flex flex-col gap-1 body-sm">
      <div className="flex items-center text-gray-300 ">
        <span className="mr-[4px]">Ranks From</span>
        <Icon name={RANK_ICONS[determineRank(player.rank, rankThreshold)]} />
        <span className="ml-[2px]">{numberWithCommas(rankThreshold)}</span>
        <span className="ml-auto text-white">{formattedRankGap}</span>
      </div>
      {pointsNeeded > 0 ? (
        <div className="flex items-center text-gray-300 body-sm">
          <span className="mr-[4px]">Points Needed</span>
          <div className="ml-auto text-white flex gap-[4px] items-center">
            <Icon name="arcade" className="w-[14px] h-[14px]" />
            <span className="overflow-hidden">
              <InventoryStat value={pointsNeeded} />
            </span>
          </div>
        </div>
      ) : null}
      <div className="flex items-center text-gray-300">
        <div>Available Points</div>
        <div className="ml-auto text-white flex gap-[4px] items-center">
          <Icon name="arcade" className="w-[14px] h-[14px]" />
          <div className="text-arcadeGreen overflow-hidden">
            <InventoryStat value={availablePoints} />
          </div>
        </div>
      </div>
    </section>
  )
}
